<template>
  <s-page class="max-w-2xl mx-auto font-degular" v-if="isDataLoaded">
    <ordering-list />
    <modal-submit-order />
  </s-page>
</template>

<script>
import SPage from '@/components/SPage'
import OrderingList from '@/components/OrderingList'
import ModalSubmitOrder from '@/components/ModalSubmitOrder'
import { mapState } from 'vuex'

export default {
  name: 'Ordering',
  components: {
    SPage,
    OrderingList,
    ModalSubmitOrder
  },
  computed: {
    ...mapState('config', ['isDataLoaded'])
  }
}
</script>
